import { emptyDeck } from './stableDiscoveryDeck';
const memory = new Map();
export function readDiscoveryState(scope) {
  const key = `POSTPOP_WEB_DISCOVERY_V1_${scope}`;
  if (memory.has(key)) return memory.get(key);
  try {
    const state = JSON.parse(localStorage.getItem(key)) || memory.get(key);
    if (
      state &&
      Array.isArray(state.deck?.ids) &&
      state.deck.introduced &&
      state.deck.seen &&
      state.deck.clicked &&
      Number.isSafeInteger(state.rotation) &&
      state.rotation >= 0 &&
      Array.isArray(state.tracks)
    )
      return state;
  } catch {
    /* Blocked or malformed storage falls back to this session. */
  }
  return memory.get(key) || { deck: emptyDeck(), rotation: 0, tracks: [], awayAt: null };
}
export function writeDiscoveryState(scope, state) {
  const key = `POSTPOP_WEB_DISCOVERY_V1_${scope}`;
  memory.set(key, state);
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch {
    /* Keep session state. */
  }
}
export function trackReturnRounds(elapsed) {
  return !Number.isFinite(elapsed) || elapsed < 60000 ? 0 : elapsed >= 8 * 3600000 ? 2 : 1;
}
